@if (inlineMode) {
  <ion-modal
    [isOpen]="isOpen"
    [show-backdrop]="true"
    [id]="id"
    backdrop-dismiss="false"
    class="cancelable-loading"
    (willPresent)="setCancelButtonVisibility()"
    (didDismiss)="modalDidDismiss()"
  >
    <ng-template>
      <div class="loading-info" autoMode>
        <div><ion-spinner class="spinner" aria-hidden="true" [name]="spinner" role="progressbar"></ion-spinner></div>
        <div class="text-wrapper" autoMode>{{ loadingMsg | translateText:translateLoadingMsg }}</div>
      </div>
  
      @if (cancelButtonVisible && !cancelIsDeactivated) {
        <div class="button-wrapper" autoMode>
          <ion-button #cnclBtnRef class="cancel-button" (click)="cancelButtonClicked()" tabindex="0">
            {{ "BUTTONS.CANCEL" | translate }}
          </ion-button>
        </div>
      }
    </ng-template>
  </ion-modal>
} @else {
  <div class="loading-info" autoMode>
    <div><ion-spinner class="spinner" aria-hidden="true" [name]="spinner" role="progressbar"></ion-spinner></div>
    <div class="text-wrapper" autoMode>{{ loadingMsg | translateText:translateLoadingMsg }}</div>
  </div>

  @if (cancelButtonVisible && !cancelIsDeactivated) {
    <div class="button-wrapper" autoMode>
      <ion-button #cnclBtnRef class="cancel-button" (click)="cancelButtonClicked()" tabindex="0">
        {{ "BUTTONS.CANCEL" | translate }}
      </ion-button>
    </div>
  }
}

@if (confirmCancellation && !cancelIsDeactivated) {
  <ion-alert
    #cnfDialogRef
    [header]="cnfHeader | translateText:translateCnfHeader"
    [subHeader]="cnfSubHeader | translateText:translateCnfSubHeader"
    [message]="cnfMsg | translateText:translateCnfMsg"
    [buttons]="cnfButtons"
    backdropDismiss="false"
    (didDismiss)="makeButtonTabFocusable(true)"
  ></ion-alert>
}
